<script>
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    props: {
        officeHourItem: {
            type: Object,
            required: true,
            default: {},
        },
        options: {
            type: Array,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        handleDaysChange: {
            type: Function,
            required: true,
        },
        deleteItems: {
            type: Function,
            required: true,
        },
        handleTimeChange: {
            type: Function,
            required: true,
        },
        checkErrors: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            daysValue: [],
            from_time: null,
            to_time: null,
        };
    },
    created() {
        this.daysValue = this.officeHourItem.day;
        this.from_time = this.officeHourItem.from_time;
        this.to_time = this.officeHourItem.to_time;
    },
};
</script>

<template>
    <div class="shadow card mb-3">
        <div class="card-body row">
            <div class="col-12 col-sm-12 col-md-4 col-xl-5 mb-3">
                <label class="form-label">Days</label>
                <Multiselect
                    v-model="daysValue"
                    placeholder="Select Days"
                    label="name"
                    track-by="name"
                    :options="options"
                    :multiple="true"
                    :taggable="true"
                    :hide-selected="true"
                    @select="handleDaysChange($event, index, 'select')"
                    @remove="handleDaysChange($event, index, 'remove')"
                ></Multiselect>
                <div
                    v-if="checkErrors(`allItems.${index}.day`)"
                    class="text-danger mt-1"
                >
                    {{ checkErrors(`allItems.${index}.day`)[0] }}
                </div>
            </div>
            <div class="col-12 col-sm-5 col-md-3 col-xl-3 mb-3">
                <label class="form-label">From Time</label>
                <b-form-timepicker
                    v-model="from_time"
                    now-button
                    locale="en"
                    size="lg"
                    class="border border-3"
                    :class="{
                        'is-invalid': checkErrors(
                            `allItems.${index}.from_time`
                        ),
                    }"
                    @input="handleTimeChange($event, index, 'from_time')"
                ></b-form-timepicker>
                <div
                    v-if="checkErrors(`allItems.${index}.from_time`)"
                    class="invalid-feedback fs-6"
                >
                    {{ checkErrors(`allItems.${index}.from_time`)[0] }}
                </div>
            </div>
            <div class="col-12 col-sm-5 col-md-3 col-xl-3 mb-3">
                <label class="form-label">To Time</label>
                <b-form-timepicker
                    v-model="to_time"
                    now-button
                    locale="en"
                    size="lg"
                    class="border border-3"
                    :class="{
                        'is-invalid': checkErrors(`allItems.${index}.to_time`),
                    }"
                    @input="handleTimeChange($event, index, 'to_time')"
                ></b-form-timepicker>
                <div
                    v-if="checkErrors(`allItems.${index}.to_time`)"
                    class="invalid-feedback fs-6"
                >
                    {{ checkErrors(`allItems.${index}.to_time`)[0] }}
                </div>
            </div>
            <div class="col-12 col-sm-2 col-md-2 col-xl-1 mt-sm-4">
                <button
                    @click="deleteItems(index)"
                    type="button"
                    class="btn btn-danger waves-effect waves-light w-100 mt-sm-1"
                >
                    <i class="mdi mdi-trash-can d-block font-size-16"></i>
                </button>
            </div>
        </div>
    </div>
</template>
